module.exports = __webpack_public_path__ + "static/img/yinpin.47c310cc.svg";